import type {RegionControllerGetRegionsQueryParams} from "@/global/api/gen/ts/RegionDTO/RegionControllerGetRegions";
import type {
    RegionControllerGetLocalitiesByRegionIdQueryParams
} from "@/global/api/gen/ts/RegionDTO/RegionControllerGetLocalitiesByRegionId";

export const RegionsKeys = {
    all: ['regions'] as const,
    search: (params: RegionControllerGetRegionsQueryParams) => [...RegionsKeys.all, 'search', params] as const,
    localities: (id:number | string, params: RegionControllerGetLocalitiesByRegionIdQueryParams)=> [...RegionsKeys.all, `${id}`, params] as const,
};